<template>
  <div :class="['col-xs-12', `col-md-${size}`]">
    <form-group-search-select
      ref="input"
      :label="label"
      :readonly="readonly"
      :value="value"
      :name="name"
      :options="formas"
      :data-vv-as="label"
      :placeholder="placeholder"
      @input="$emit('input', $event)"
      @change="$emit('input', $event)"
      v-validate="{ required: required }"
    />
  </div>
</template>

<script>
export default {
  name: "c-protocolo-forma-pagamento-parcelas-amortizacao",
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator", "formValues"],
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    size: {
      type: String,
      default: "6"
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: Array,
    required: Boolean
  },
  data() {
    return {
      formas: [
        { value: "06 (seis) parcelas mensais sem juros", text: "06 (seis) parcelas mensais sem juros" },
        { value: "06 (seis) parcelas recorrentes mensais no cartão de crédito sem juros", text: "06 (seis) parcelas recorrentes mensais no cartão de crédito sem juros" },
        { value: "12 (doze) parcelas mensais com juros 0,7% ao mês", text: "12 (doze) parcelas mensais com juros 0,7% ao mês" },
        { value: "12 (doze) parcelas recorrentes mensais no cartão de crédito sem juros", text: "12 (doze) parcelas recorrentes mensais no cartão de crédito sem juros" },
        { value: "18 (dezoito) parcelas mensais com juros de 0,8% ao mês", text: "18 (dezoito) parcelas mensais com juros de 0,8% ao mês" },
        { value: "24 (vinte e quatro) parcelas mensais com juros de 0,9% ao mês", text: "24 (vinte e quatro) parcelas mensais com juros de 0,9% ao mês" }
      ]
    };
  },
  mounted() {
    this.$el.value = this.value;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/FormaPagamentoParcelasAmortizacao.vue